import RequestError from "./RequestError";
import { PRECONDITION_FAILED } from "./fetch";

const EmptyPreconditionFailedError = () =>
    new RequestError({ status: PRECONDITION_FAILED, response: { body: { fieldErrors: [] } } }, false);

export default EmptyPreconditionFailedError;
